// extracted by mini-css-extract-plugin
module.exports = {"shaker":"speedometer_shaker__hI_ig","shake":"speedometer_shake__3HCpu"};